import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 168420 170291"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528315461648">
        <path
          d="M157830 170291H10571C4751 170291 0 165538 0 159718s4731-10570 10571-10570h147259c5820 0 10570 4750 10570 10573 0 5837-4733 10570-10570 10570zM10571 152315c-4085 0-7406 3321-7406 7406 0 4082 3321 7402 7406 7402h147259c4082 0 7403-3320 7403-7405 0-4082-3321-7403-7403-7403H10571z"
          className="fil0"
        />
        <path
          d="M155005 152315h-10000c-876 0-1582-706-1582-1582V12652H24652v138078c0 879-706 1585-1583 1585h-9999c-877 0-1583-706-1583-1582V12652H1603c-879 0-1585-707-1585-1586V1583C18 706 724 0 1603 0h165232c879 0 1585 706 1585 1583v9483c0 879-706 1586-1585 1586h-10247v138078c0 879-706 1585-1583 1585zm-8414-3167h6829V11066c0-876 706-1582 1585-1582h10228V3168H3165v6316h9887c877 0 1583 706 1583 1582v138082h6832V11066c0-876 706-1582 1582-1582h121936c879 0 1586 706 1586 1582v138082h20z"
          className="fil0"
        />
        <path
          d="M33222 137069c-6469 0-11735-5266-11735-11755 0-879 703-1585 1582-1585 877 0 1583 706 1583 1585 0 4733 3857 8567 8587 8567 4733 0 8588-3854 8588-8567v-8091c0-879 706-1583 1585-1583 876 0 1582 704 1582 1583 0 4733 3857 8567 8588 8567 4733 0 8569-3854 8569-8567v-8091c0-877 706-1583 1583-1583 879 0 1585 706 1585 1583 0 4733 3854 8587 8567 8587s8567-3854 8567-8587v-8054c0-877 707-1583 1586-1583 876 0 1582 706 1582 1583 0 4733 3854 8590 8588 8590 4733 0 8587-3857 8587-8590v-8089c0-879 706-1585 1582-1585 879 0 1586 706 1586 1585 0 4731 3854 8567 8587 8567s8587-3854 8587-8567v-8091c0-879 706-1586 1583-1586 879 0 1585 707 1585 1586 0 4730 3854 8567 8587 8567s8567-3854 8567-8567c0-879 707-1586 1586-1586 876 0 1582 707 1582 1586 0 6468-5266 11735-11735 11735-3378 0-6431-1433-8587-3722 0 6547-5267 11813-11735 11813-3378 0-6431-1432-8587-3741 0 6546-5267 11812-11738 11812-3376 0-6428-1432-8587-3741 0 6546-5267 11813-11735 11813-3378 0-6431-1430-8567-3722 0 6547-5267 11813-11738 11813-3376 0-6428-1432-8587-3721-75 6566-5342 11832-11810 11832z"
          className="fil0"
        />
        <path
          d="M43392 118826c-877 0-1583-707-1583-1586V80317c0-879 706-1585 1583-1585 879 0 1585 706 1585 1585v36923c-20 879-726 1586-1585 1586zM63714 110734c-877 0-1583-706-1583-1582V35759c0-877 706-1583 1583-1583 879 0 1585 706 1585 1583v73393c0 876-726 1582-1585 1582zM84039 102663c-879 0-1586-706-1586-1585V69441c0-879 707-1585 1586-1585 876 0 1582 706 1582 1585v31637c-20 859-726 1585-1582 1585zM104361 94572c-879 0-1585-706-1585-1583V51941c0-876 706-1582 1585-1582 876 0 1583 706 1583 1582v41048c0 877-724 1583-1583 1583zM124683 86480c-879 0-1583-706-1583-1582V25531c0-876 704-1583 1583-1583 877 0 1583 707 1583 1583v59367c0 876-724 1582-1583 1582z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
